import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// fix：重复路径跳转报错
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

const router = new VueRouter({
  mode: 'hash',
  // base: import.meta.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: '/',
      component: () => import('@/layout/laidong.vue'),
      redirect: '/home',
      meta: {
        isKeepAlive: true,
      },
      children: [
        {
          path: '/home',
          name: 'home',
          component: () => import('@/views/home/index.vue'),
          meta: {
            title: '首页',
            isLink: '',
            isHide: false,
            isKeepAlive: true,
            isAffix: true,
            isIframe: false,
            roles: ['admin', 'common'],
            icon: 'iconfont icon-shouye',
          },
        },
        {
          path: '/product',
          name: 'product',
          component: () => import('@/views/home/product.vue'),
          meta: {
            title: '首页',
            isLink: '',
            isHide: false,
            isKeepAlive: true,
            isAffix: true,
            isIframe: false,
            roles: ['admin', 'common'],
            icon: 'iconfont icon-shouye',
          },
        },
        {
          path: '/Mypublish',
          name: 'Mypublish',
          component: () => import('@/views/home/Mypublish.vue'),
          meta: {
            title: '首页',
            isLink: '',
            isHide: false,
            isKeepAlive: true,
            isAffix: true,
            isIframe: false,
            roles: ['admin', 'common'],
            icon: 'iconfont icon-shouye',
          },
        },
        {
          path: '/login',
          name: 'login',
          component: () => import('@/views/home/login.vue'),
          meta: {
            title: '首页',
            isLink: '',
            isHide: false,
            isKeepAlive: true,
            isAffix: true,
            isIframe: false,
            roles: ['admin', 'common'],
            icon: 'iconfont icon-shouye',
          },
        },
        {
          path: '/publishInfo',
          name: 'publishInfo',
          component: () => import('@/views/home/publishInfo.vue'),
          meta: {
            title: '首页',
            isLink: '',
            isHide: false,
            isKeepAlive: true,
            isAffix: true,
            isIframe: false,
            roles: ['admin', 'common'],
            icon: 'iconfont icon-shouye',
          },
        },
        {
          path: '/consultation',
          name: 'consultation',
          component: () => import('@/views/home/consultation.vue'),
          meta: {
            title: '首页',
            isLink: '',
            isHide: false,
            isKeepAlive: true,
            isAffix: true,
            isIframe: false,
            roles: ['admin', 'common'],
            icon: 'iconfont icon-shouye',
          },
        },
        {
          path: '/Useragr',
          name: 'Useragr',
          component: () => import('@/views/home/Useragr.vue'),
          meta: {
            title: '首页',
            isLink: '',
            isHide: false,
            isKeepAlive: true,
            isAffix: true,
            isIframe: false,
            roles: ['admin', 'common'],
            icon: 'iconfont icon-shouye',
          },
        },
        {
          path: '/private',
          name: 'private',
          component: () => import('@/views/home/private.vue'),
          meta: {
            title: '首页',
            isLink: '',
            isHide: false,
            isKeepAlive: true,
            isAffix: true,
            isIframe: false,
            roles: ['admin', 'common'],
            icon: 'iconfont icon-shouye',
          },
        },
        {
          path: '/publishCheck',
          name: 'publishCheck',
          component: () => import('@/views/home/publishCheck.vue'),
          meta: {
            title: '首页',
            isLink: '',
            isHide: false,
            isKeepAlive: true,
            isAffix: true,
            isIframe: false,
            roles: ['admin', 'common'],
            icon: 'iconfont icon-shouye',
          },
        },
        {
          path: '/register',
          name: 'register',
          component: () => import('@/views/home/register.vue'),
          meta: {
            title: '首页',
            isLink: '',
            isHide: false,
            isKeepAlive: true,
            isAffix: true,
            isIframe: false,
            roles: ['admin', 'common'],
            icon: 'iconfont icon-shouye',
          },
        },
      ],
    },
    {
      path: '/vip',
      name: '/vip',
      component: () => import('@/layout/laidongVip.vue'),
      redirect: '/vip',
      meta: {
        isKeepAlive: true,
      },
      children: [
        {
          path: '/vip',
          name: 'vip',
          component: () => import('@/views/vip/vip.vue'),
          meta: {
            title: '会员中心',
            isLink: '',
            isHide: false,
            isKeepAlive: true,
            isAffix: true,
            isIframe: false,
            roles: ['admin', 'common'],
            icon: 'iconfont icon-shouye',
          },
        },
      ],
    },
  ],
});

export default router;
